import { render } from "./CommunityAdPurchaseView.vue?vue&type=template&id=5d9f107c&scoped=true"
import script from "./CommunityAdPurchaseView.vue?vue&type=script&lang=js"
export * from "./CommunityAdPurchaseView.vue?vue&type=script&lang=js"

import "./CommunityAdPurchaseView.vue?vue&type=style&index=0&id=5d9f107c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9f107c"]])

export default __exports__